<table
  mat-table
  [dataSource]="tableDataSource"
  matSort
  aria-describedby="RaceEventDataItem"
>
  @for (column of dataSource?.columns; track column) { @if (!column.menuItem) {
  <ng-container matColumnDef="{{ column.property }}">
    <th
      scope="col"
      mat-header-cell
      [ngClass]="column.class"
      *matHeaderCellDef
      mat-sort-header
    >
      {{ column.header }}
    </th>
    <td
      mat-cell
      *matCellDef="let row"
      [matBadge]="
        row['cellMetaMap']?.get(column.property)?.hasMultipleGenerations
          ? '!'
          : ''
      "
      [matBadgeColor]="'primary'"
      [ngClass]="row['cellMetaMap']?.get(column.property)?.cellClass"
    >
      @if ( (row[column.property] | typeOfPipe) === 'array') { @for (element of
      row[column.property]; track element) {
      <div>
        <span
          [innerHtml]="element | highlight: row['highligt']:'redbold'"
        ></span>
      </div>
      } } @if ((row[column.property] | typeOfPipe) !== 'array' &&
      (row[column.property] | typeOfPipe) !== 'boolean') { @if
      (row['cellMetaMap']?.get(column.property)?.icon) {
      <button mat-icon-button matRipple (click)="iconClick($event, row)">
        <mat-icon
          [svgIcon]="row['cellMetaMap']?.get(column.property)?.icon"
        ></mat-icon>
      </button>
      }
      {{ row[column.property] }}
      } @if ((row[column.property] | typeOfPipe) !== 'array' &&
      (row[column.property] | typeOfPipe) === 'boolean') { @if
      (row['inlineEdit'] === column.property) {
      <mat-slide-toggle
        [color]="'primary'"
        (change)="toggle($event, row, row['inlineEdit'])"
        [checked]="row[column.property]"
      >
      </mat-slide-toggle>
      } @if (row['inlineEdit'] !== column.property) {
      <mat-icon
        [ngClass]="row[column.property] ? 'green' : 'red'"
        [svgIcon]="row[column.property] ? 'done' : 'close'"
      ></mat-icon>
      } }
    </td>
  </ng-container>
  } @if (column.menuItem) {
  <ng-container matColumnDef="{{ column.property }}">
    <th scope="col" mat-header-cell *matHeaderCellDef></th>
    <td
      mat-cell
      *matCellDef="let row"
      class="center"
      (click)="$event.stopImmediatePropagation()"
      (keydown)="$event.stopImmediatePropagation()"
    >
      <button mat-icon-button [matMenuTriggerFor]="meraMeny">
        <mat-icon svgIcon="more_horiz" class="grey"></mat-icon>
      </button>
      <mat-menu #meraMeny="matMenu" class="meny">
        @for (menuItem of column.menuItem; track menuItem) {
        <button mat-menu-item (click)="action(row, menuItem.action)">
          {{ menuItem.header }}
        </button>
        }
      </mat-menu>
    </td>
  </ng-container>
  } }
  <tr
    mat-header-row
    *matHeaderRowDef="columnProperties"
    class="header-row"
    tabindex="0"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: columnProperties"
    tabindex="0"
    class="element-row keyboardFocusRow"
    [ngClass]="{ slim: dataSource?.slim }"
    (keydown)="rowkeyDown($event, row)"
    (click)="rowClick($event, row)"
    faxeExpandedTableRow
    [detailRow]="row"
    [templateRef]="tpl"
  ></tr>
</table>

@if (dataSource?.showPaginator) {
<mat-paginator
  #paginator
  class="paginator"
  [pageSizeOptions]="[200, 400, 800]"
></mat-paginator>
}

<ng-template #tpl let-row="$implicit">
  @if (row.detailTable) {
  <tr class="mat-row">
    <td colspan="4">
      <faxe-table
        [data]="row.detailTable"
        (menyAction)="childAction($event)"
      ></faxe-table>
    </td>
  </tr>
  }
</ng-template>
